export default "__VITE_ASSET__FHB5vPm3__"